// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login-button-module--wrapper--_Sndu","bordered":"login-button-module--bordered--SihEI","userName":"login-button-module--userName--16bjQ"};